// app/store.js
import { configureStore } from "@reduxjs/toolkit";
import searchReducer from "./reducers/searchSlice";

const store = configureStore({
  reducer: {
    search: searchReducer,
  },
});

export default store;
